import {combineReducers} from "redux";
import {Location} from "history";
import {routerReducer as routing} from 'react-router-redux';
import {IceClient, IceClientState} from "@neolab/ice-client";

import routes, {RoutesState} from "src/routes/reducer";

import user, {UserState} from "./user";


export interface RootState {
  routing: {
    locationBeforeTransitions: Location;
  };

  routes: RoutesState;

  iceClient: IceClientState;
  
  user: UserState;
}

export default function createReducer(iceClient: IceClient) {
  return combineReducers<RootState>({
    routing,

    routes,

    iceClient: iceClient.reducer,

    user,
  });
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/index.ts